import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { OnboardingService } from './onboarding.service';

@Injectable({
  providedIn: 'root'
})
export class AuthResolveGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private onboardingService: OnboardingService
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    this.authenticationService.checkUserAuthenticated().subscribe((res) => {
      console.log(res)
      if (res.userId <= 0) {
        return false
      } else {
        if (!this.onboardingService.userDetails.isOtpVerified) {
          this.router.navigate(['/verification'], { state: { userId: this.onboardingService.userDetails.id } })
        } else if (!this.onboardingService.userDetails.isSetupVisited) {
          this.router.navigate(['userProfiles/${res.id}/setup/1'])
        } else {
          window.location.href = "/";
        }
        return true;
      }
    }, err => {

    })
    return true;
  }
}
